import React from 'react';
import { useOutletContext } from 'react-router-dom';
import useSeo from '../seo';

const SERVICES = [
  {
    icon: '🤝',
    title: 'We configure it with you — not hand you a login',
    body: 'Our deployment is to sit with your finance and operations teams and set the system up around how your business actually runs. Master data, cost structures, bills of material, rates and reporting hierarchies are configured for the best possible outcome before your first cycle opens.',
  },
  {
    icon: '📊',
    title: '15+ years of budgeting for large multinationals',
    body: 'We have built and run budgets inside big multi-national businesses, not just software for them. That experience comes with the platform: what to model, what to leave alone, and where budget cycles usually break.',
  },
  {
    icon: '🎯',
    title: 'Your Budget, LE and Forecast cycles land',
    body: 'Budget, Latest Estimate and Profit Forecast are deadlines, not projects. We work alongside your business team through the cycle so the numbers on Mantle are complete, defensible and on time.',
  },
  {
    icon: '⚡',
    title: 'Agentic change management — days, not weeks',
    body: 'When your business changes, the model has to change with it. We use agentic, AI-assisted development to turn configuration and change requests around in days — instead of the weeks or roadmap quarters a conventional SaaS implementation makes you wait.',
  },
];

const Services = () => {
  const { openAudit } = useOutletContext();

  useSeo('/services');

  return (
    <>
      <section className="mn-section" id="services">
        <div className="mn-container">
          <div className="mn-section-head">
            <span className="mn-kicker">Services & Deployment</span>
            <h1>You don’t just get the platform. You get the people who run budgets for a living.</h1>
            <p>
              Software on its own has never delivered a budget cycle. Mantle comes with a team that
              has spent 15+ years building budgets for large multi-national companies — and we stay
              with you until your cycle is running.
            </p>
          </div>

          <div className="mn-svc-grid">
            {SERVICES.map((s) => (
              <div className="mn-svc-item" key={s.title}>
                <div className="mn-svc-icon" aria-hidden="true">{s.icon}</div>
                <div>
                  <h2>{s.title}</h2>
                  <p>{s.body}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mn-svc-band">
            <div className="mn-svc-stat">
              <strong>15+ yrs</strong>
              <span>Multi-national budgeting experience</span>
            </div>
            <div className="mn-svc-stat">
              <strong>Sit-with-you</strong>
              <span>Configuration, not a handover pack</span>
            </div>
            <div className="mn-svc-stat">
              <strong>Days</strong>
              <span>Turnaround on changes, not weeks</span>
            </div>
          </div>
        </div>
      </section>

      {/* --------------------------------------------------------- CTA --- */}
      <section className="mn-section mn-section-alt mn-cta-band">
        <div className="mn-container">
          <h2>Let’s configure Mantle around your business.</h2>
          <p>
            Book a Discovery Audit and we’ll map your value chain, your cycle dates and the modules
            you actually need.
          </p>
          <div className="mn-hero-actions">
            <button type="button" className="mn-btn mn-btn-primary mn-btn-lg" onClick={openAudit}>
              Request a Discovery Audit
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
